module.exports = {"home":"HOME","video":"VIDEO","role":"HERO","map":"SENGOKU MAP","summary":"INTRODUCTION","company":{"text1":"Terms of Services","text2":"Privacy Policy","text3":"","text4":"","text5":"","text6":"","text7":""},"index":{"channel_text":"DOWNLOAD NOW"},"new":{"all":"ALL","tz":"NEWS","wh":"UPDATES","hd":"EVENT","prev":"PREVIOUS","next":"NEXT","news":"NEWS","top":"TOP"},"phonetext":{"new":"LATEST","fb":"FACEBOOK"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = NuBg
// module chunks = 1